import { computed, defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import ImageContainer from "@/views/creative/components/image-container.vue";
import VideoContainer from "@/views/creative/components/video-container.vue";
import SequenceFrameContainer from "@/views/creative/components/frame-sequence.vue";
import AudioContainer from "@/views/creative/components/audio-container.vue";
import { defaultCoverPreviews } from "@/views/repository/resource/config/methods";
import { fmtSeconds } from "@com/utils/data-format";
import { TabsType } from "../config/enums";
import store from "@/store";
export default defineComponent({
    name: "item-modular",
    components: {
        ImageContainer: ImageContainer,
        VideoContainer: VideoContainer,
        AudioContainer: AudioContainer,
        SequenceFrameContainer: SequenceFrameContainer
    },
    props: {
        resource: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        },
        index: {
            type: definePropType(Number),
            default: 0
        }
    },
    setup: function setup(props) {
        var activeTab = computed(function() {
            return store.state.resource.activeTab;
        });
        var imageStyle = computed(function() {
            return {
                width: "200px",
                height: "150px",
                maxWidth: "200px",
                maxHeight: "150px",
                display: "flex",
                "align-items": "center",
                "justify-content": "center"
            };
        });
        var setDuration = computed(function() {
            return fmtSeconds(props.resource.file_meta.duration / 1000);
        });
        var setImgUrl = computed(function() {
            var file_url = "";
            if (// 动图gif、图片
            (props.resource.file_meta && props.resource.file_meta.format === "gif") || props.resource.type === 2) {
                file_url = props.resource.file_url;
            } else if (props.resource.thumb_url) {
                // 字体、龙骨、粒子
                file_url = props.resource.thumb_url;
            } else if (props.resource.cover_previews) {
                // 片段
                file_url = defaultCoverPreviews(props.resource);
            }
            return file_url;
        });
        return {
            activeTab: activeTab,
            imageStyle: imageStyle,
            setDuration: setDuration,
            setImgUrl: setImgUrl,
            TabsType: TabsType
        };
    }
});
